<script>
    import AlphabetAnimation from '../../../reusableitems/homepagewordsanimation/wordsanimation.svelte';
    import TwoInOnebutton from '../../../reusableitems/TwoInOnebutton.svelte';
    // let currentWord = 0;
    // let displayN = false;
    /**
     *
     *
     */
    // function timeUp() {
    //     displayN = false;
    // }
    // $: if (currentWord === 3) {
    //     displayN = true;
    //     setTimeout(timeUp, 5000);
    // }
</script>

<div class="main-div">
    <div class="main-text">
        <p class="text1">OUR</p>
        <p class="text2">TECHNOLOGY</p>
        <p class="text3">turns text to</p>
        <!-- {#if displayN === true}
            <p class="text4">N</p>
        {/if} -->
    </div>
    <div class="animated-word">
        <AlphabetAnimation />
    </div>

    <div class="middle_content">
        <div class="content-text1"><p>OpusAI</p></div>
        <hr />
        <div class="content-text2">
            <p style="margin-bottom: 2.130vh;">
                Let’s build the future of decentralized entertainment together.
            </p>
            <p>
                We are a self sustaining decentralized global community of
                <span
                    >Dreamers, Gamers, Artists, Storytellers, Musicians,
                    Advertisers, Investors and Technical Creators</span
                >
            </p>
        </div>
    </div>
    <div style="display: flex;margin-top:3.241vh;">
        <div class="social_links">
            <a
                rel="noreferrer"
                href="https://twitter.com/OpusAIInc"
                target="_blank"
            >
                <img
                    class="social1"
                    src="/images/story_section/twitter.svg"
                    alt=""
                />
            </a>
            <a
                rel="noreferrer"
                href="https://www.linkedin.com/company/opusai"
                target="_blank"
            >
                <img
                    class="social2"
                    src="/images/story_section/linkdin.svg"
                    alt=""
                />
            </a>
            <a
                rel="noreferrer"
                href="https://www.youtube.com/c/opusai"
                target="_blank"
            >
                <img
                    class="social3"
                    src="/images/story_section/youtube.svg"
                    alt=""
                />
            </a>
            <!-- <img on:click={() => {
                    window.open('https://discord.gg/Mz3t8NsN', '_blank');
                }}
                class="social4"
                src="/images/story_section/Discord.svg"
                alt=""
            /> -->
        </div>

        <div class="btn">
            <TwoInOnebutton />
        </div>

        <div class="scroll_div">
            <p>Scroll / Drag</p>
            <img src="/images/story_section/arrow.svg" alt="" />
        </div>
    </div>
</div>

<style>
    .animated-word {
        display: flex;
        justify-content: center;
        height: 7.037vh;
    }
    p {
        margin: 0;
    }
    .main-div {
        width: 88.889vh;
        height: 100%;
        /* padding-top: 5.648vh; */
        font-family: "Orbitron";
        background-color: black;
    }
    .main-text {
        margin-left: 12.685vh;
        width: 53.698vh;
    }
    .text1 {
        color: white;
        font-size: 3.704vh;
        font-weight: 900;
        line-height: 4.644vh;
        text-transform: uppercase;
        padding-top: 18.889vh;
        margin: 0;
    }
    .text2 {
        color: black;
        font-size: 7.407vh;
        font-weight: 900;
        line-height: 7.611vh;
        text-transform: uppercase;
        -webkit-text-stroke: 0.185vh white;
        margin: 0;
    }
    .text3 {
        color: white;
        font-size: 3.704vh;
        font-weight: 900;
        line-height: 5.967vh;
        text-transform: uppercase;
        margin: 0;
        width: 35vh;
        text-align: end;
        margin-left: 23vh;
    }
    /* .text4 {
        color: white;
        font-size: max(5.556vh, 30px);
        font-weight: 900;
        line-height: max(5.967vh , 37.62px);
        text-transform: uppercase;
        margin-left: max(38.3vh,206.82px);
        margin-top: -5.77vh;
        margin-bottom: 0;
        animation: ani 5s 0.001s ;
    } */
    @keyframes ani {
        0% {
            opacity: 0;
        }
        20% {
            opacity: 0.5;
        }
        50% {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }
    /* .text4 {
        color: #da22ff;
        font-size: 9.259vh;
        font-weight: 900;
        line-height: 7.611vh;
        text-transform: uppercase;
        margin: 0;
    } */
    .middle_content {
        margin-top: 13.519vh;
        display: flex;
        justify-content: center;
        margin-left: 7.7vh;
    }

    hr {
        margin: 0 3.704vh;
        border: none;
        background-color: white;
        width: 0.093vh;
    }
    .content-text1 {
        color: white;
        font-size: 1.852vh;
        line-height: 2.322vh;
        font-weight: 400;
        display: flex;
        align-items: center;
    }
    .content-text2 {
        padding: 0.5vh 0vh;
    }
    .content-text2 p {
        width: 31.889vh;
        font-size: 1.296vh;
        font-weight: 400;
        line-height: 1.944vh;
        color: white;
    }
    .content-text2 span {
        font-size: 1.296vh;
        font-weight: 900;
        line-height: 1.944vh;
        color: white;
    }
    .social_links {
        width: 4vh;
        text-align: center;
        cursor: pointer;
        position: relative;
        bottom: 0vh;
        left: 6vh;
    }
    .social1 {
        margin-bottom: 3.241vh;
        width: 2.407vh;
        height: 1.852vh;
    }
    .social2 {
        margin-bottom: 3.241vh;
        width: 2.444vh;
        height: 2.444vh;
    }
    .social3 {
        margin-bottom: 3.241vh;
        width: 2.778vh;
        height: 2.13vh;
    }
    .btn {
        margin-top: 2.315vh;
        margin-left: 38.8vh;
    }
    .scroll_div {
        display: flex;
        margin-left: 22vh;
        align-items: end;
    }
    .scroll_div p {
        font-size: 1.667vh;
        font-weight: 700;
        line-height: 1.857vh;
        color: white;
        margin: 0;
    }
    .scroll_div img {
        width: 6.574vh;
        margin-bottom: 0.4vh;
        margin-left: 2vh;
    }
</style>
